import { navigations, navigationsTmp } from 'app/navigations'
import { SET_USER_NAVIGATION } from '../actions/NavigationAction'

const initialState = [...navigations]

const NavigationReducer = function (state = initialState, action) {
    //console.log('Вывод все инфы, похер на роли', action.type);
    switch (action.type) {
        case SET_USER_NAVIGATION: {
           // console.log('Должны заменить меню',state,action.payload);
            return [...action.payload]
        }
        default: {
            // console.log('Вывод все инфы, похер на роли', action.type);
            return [...state]
        }
    }
}

export default NavigationReducer
